import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34674650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ptz-control" }
const _hoisted_2 = { class: "control-dir" }
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-xiangshang" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "pause-btn" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-24gf-pause2" })
  ])
], -1))
const _hoisted_7 = { class: "control-focus" }
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = { class: "txt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns.dir, (val, key) => {
        return (_openBlock(), _createElementBlock("span", {
          key: key,
          class: _normalizeClass(`slice control-${key} ${_ctx.acitveBtn === val ? 'active' : ''}`),
          onMousedown: ($event: any) => (_ctx.handleControl(val)),
          onMouseup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleControl('stop')))
        }, _hoisted_5, 42, _hoisted_3))
      }), 128)),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns.focus, (val, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(`focus-item ${_ctx.acitveBtn === val.command ? 'active' : ''}`),
          onMousedown: ($event: any) => (_ctx.handleControl(val.command)),
          onMouseup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleControl('stop')))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(['iconfont', val.icon])
          }, null, 2),
          _createElementVNode("span", _hoisted_9, _toDisplayString(val.label), 1)
        ], 42, _hoisted_8))
      }), 128))
    ])
  ]))
}